/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsSwitchCreateBody = zod.strictObject({
    account_id: zod.number(),
});

export type ApiAccountsSwitchCreateBody = zod.input<
    typeof ApiAccountsSwitchCreateBody
>;
export type ApiAccountsSwitchCreateBodyOutput = zod.output<
    typeof ApiAccountsSwitchCreateBody
>;
